import { Dispatch, SetStateAction, useCallback } from "react";
import { useAsyncResult } from "../UseAsyncResult";
import { fetchExtensions } from "../../Api/ado.api";
import { ExtensionFolder } from "../../Types";

export function useFetchExtensionFolders(
  setError: Dispatch<SetStateAction<string | null>>,
) {
  const func = useCallback(async (_disposable, _force) => {
    const value = await fetchExtensions();

    if (!value) {
      return [];
    }
    const isExtensionFolder = (folder: ExtensionFolder) => {
      return (
        folder.isFolder &&
        folder.path.includes("/Extensions") &&
        !folder.path.includes(".pipelines") &&
        !folder.path.includes("/Templates") &&
        folder.path !== "/Extensions"
      );
    };
    const filteredFolders = value.filter(isExtensionFolder).map((folder) => {
      const splitFolder = folder.path.split("/");
      return {
        ...folder,
        rootExtension: splitFolder[2] || "Unknown",
        extensionRepoPath: folder.path.replace("/Extensions/", ""),
        name: splitFolder.pop() || "Unknown",
      };
    });

    return filteredFolders;
  }, []);

  return useAsyncResult({
    func,
    setError,
  });
}
